// import { usersConnected, userDisconnected } from './modules/User/UserActions';
// let loggedInUser = null;

// import appListener from './modules/App/AppSocket';
// import userListener from './modules/User/UserSocket';

const listeners = [/* appListener, userListener */];

export default function(socket, dispatch, user, intl) {
    listeners.forEach(listener => listener(socket, dispatch, user, intl));

    // // User
    // socket.on('connectedUsers', users => {
    //     dispatch(usersConnected(users));
    // });
    //
    // socket.on('userDisconnected', user => {
    //     dispatch(userDisconnected(user));
    // });
    //
}

// export function setSocketUser(user) {
//     loggedInUser = user;
// }
